<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
        <div class="p-formgrid p-grid p-col p-mt-2 p-justify-center">
          <!-- <div class="p-field p-col-3 p-mr-5"> -->
            <!-- p-col-12 p-lg-6 -->
            <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label>{{ $t("startMonthYear") }}</label>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-7 ">
                <Dropdown
                  v-model="selectedStartMonth"
                  :options="month"
                  optionLabel="name"
                  id="ds_selectedStartMonth"
                />
              </div>
              <div class="p-field p-col">
                <Dropdown
                  v-model="selectedStartYear"
                  :options="year"
                  optionLabel="name"
                  id="ds_selectedStartYear"
                />
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label>{{ $t("endMonthYear") }}</label>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-7">
                <Dropdown
                  v-model="selectedEndMonth"
                  :options="month"
                  optionLabel="name"
                  id="ds_selectedEndMonth"
                />
              </div>
              <div class="p-field p-col">
                <Dropdown
                  v-model="selectedEndYear"
                  :options="year"
                  optionLabel="name"
                  id="ds_selectedEndYear"
                />
              </div>
            </div>
          </div>

          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label>{{ $t("selectedChart") }}</label>
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-12 p-lg-12">
                <Dropdown
                  v-model="selectedChart"
                  :options="chartOptions"
                  optionLabel="name"
                  id="ds_selectedChart"
                />
              </div>
            </div>
          </div>

          <div class="p-field p-col-3 p-lg-2 p-mt-2">
            <Button
              @click="search()"
              :label="$t('searchBtn')"
              class="p-button-info p-mt-4"
            />
          </div>
        </div>
      </div>
    </Fieldset>

    <div class="p-grid p-fluid">
      <!-- <div class="p-col-6 p-lg-6"> -->
        <div class="p-col-12 p-lg-6">
        <div class="card p-fluid p-mt-2">
          <DataTable
            :value="table"
            :scrollable="true"
            class="p-datatable-gridlines"
            scrollHeight="500px"
            :paginator="true"
            :rows="10"
            :loading="loading"
            :rowsPerPageOptions="[10, 20, 50]"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          <template #empty>{{ $t("TableEmpty") }}</template>
            <Column
              field="system_name"
              :header="$t('disaster_type')"
              headerStyle="width: 200px"
            >
              <template #body="dataTable">
                {{ dataTable.data.system_name }}
              </template>
            </Column>

            <div
              v-for="headers in headerYear"
              :key="headerYear.indexOf(headers)"
            >
              <Column :header="headers.toString()" headerStyle="width: 100px">
                <template #body="dataTable">
                  <div v-for="years in year" :key="years.id">
                    <div
                      v-if="
                        years.id == Number(`${headers}`.split('.')[2]) - 543
                      "
                    >
                      <div v-for="months in month" :key="months.id">
                        <div v-if="months.shrt == `${headers}`.split('2')[0]">
                          <div
                            v-for="amount in dataTable.data.amount.data"
                            :key="JSON.stringify(amount)"
                          >
                            <div
                              v-if="
                                amount.to_char == `${months.id}/${years.id}`
                              "
                            >
                              {{ amount.amount_type }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            </div>
          </DataTable>
        </div>
      </div>

        <!-- <div class="p-col-12 p-lg-6 ex1">
        <div class="card p-mt-2">
          <h5 class="centerText">
            {{ $t("TopicGraphStatisticDisaster") }} {{ labelGraph }}
          </h5>
           <div v-if="selectedChart.value == 'bar' || selectedChart.value == 'line' ">
                 <Chart :type="selectedChart.value" :data="barData" />
                </div>
                <div v-else>
                  <Chart :type="selectedChart.value" :data="pieData" />
                </div>
        </div>
      </div> -->


      <!-- ! -->
  


      <div class="p-col-12 p-lg-6 ex1">
       
        <div class="card p-mt-2">
          <div class="chartAreaWrapper">
          <h5 class="centerText">
            {{ $t("TopicGraphStatisticDisaster") }} {{ labelGraph }}
          </h5>
           <div v-if="selectedChart.value == 'bar' || selectedChart.value == 'line' ">
                 <Chart :type="selectedChart.value" :data="barData" class="walking-speed-chart"/>
                </div>
                <div v-else>
                  <Chart :type="selectedChart.value" :data="pieData" class="walking-speed-chart"/>
                </div>
        </div>
      </div>
      </div>
      <!-- ! -->
    </div>
  </div>
</template>

<script>
export default {
  name: "disaster-statistic",
  components: {},
  data() {
    return {
      month: this.$month,
      year: [],

      selectedStartMonth: null,
      selectedStartYear: null,
      selectedEndMonth: null,
      selectedEndYear: null,

      filters: {},
      table: [],
      barData: {},
      pieData: {},
      headerYear: [],
      label: [],
      labelGraph: "",

      chartOptions: [],
      selectedChart: { id: 1, name: "แบบ Bar", value: "bar" },

      range_arr: [],

      loading:false,
    };
  },

  watch: {
    table(val) {
    
      if (val.length != 0) {
        var letters = "0123456789ABCDEF";
        var color = "#";
        var dataset = [];
        var result = [];
        var resultPie = [];
        // var resultPie =[];

        for (let i = 0; i < val.length; i++) {
          for (let j = 0; j < val[i].amount.data.length; j++) {
            result.push(val[i].amount.data[j]);
          }
        }
        // console.log('result = ',result);

         for (let i = 0; i < val.length; i++) {
            // resultPie.push(val[i].system_id);
            resultPie.push({system_id: `${val[i].system_id}`,system_name: `${val[i].system_name}`,amount_type : 0 });
          
        }
        // console.log('resultPie = ',resultPie);
        

      // console.log('val =',JSON.stringify(val))

      for (let i = 0; i < val.length; i++) {
          for (let j = 0; j < val[i].amount.data.length; j++) {
            if (val[i].system_id == val[i].amount.data[j].system_id) {
              // console.log('resultPie[i].amount_type = ',resultPie[i].system_id,resultPie[i].amount_type);
              // console.log('val[i].amount.data[j].amount_type = ',val[i].system_id,val[i].amount.data[j].amount_type);
              resultPie[i].amount_type = Number(resultPie[i].amount_type) + Number(val[i].amount.data[j].amount_type);

            } 
            // console.log('val[i].amount.data[j] = ',val[i].amount.data[j]);
          }
        }
        // console.log('resultPie = ',resultPie);
        //  console.log('resultPie = ',resultPie);
       

        var all_amount = [];

        for (let t = 0; t < val.length; t++) {
          for (let i = 0; i < this.range_arr.length; i++) {
            for (let j = 0; j < result.length; j++) {
              if (this.range_arr[i] == result[j].to_char) {
                if (val[t].system_id == result[j].system_id) {
                  all_amount.push(`${result[j].amount_type}`);
                } else {
                  all_amount.push("0");
                }
              } else {
                all_amount.push("0");
              }
            }
          }
        }
        var number = [];
        var index;
        var all = [];
        for (let j = 0; j < val.length; j++) {
          for (let i = 1; i <= this.range_arr.length; i++) {
            index = i * result.length;
            var temp = 0;
            for (let k = index - result.length; k < index; k++) {
              temp += Number(all_amount[k]);
            }
            number.push(temp);
          }
          all_amount = all_amount.slice(index);
          all.push({ id: number });
          number = [];
        }
        // console.log('all = ',all);

//datasets of barData
        for (let j = 0; j < val.length; j++) {
          for (let k = 0; k < 6; k++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          dataset.push({
            label: `${val[j].system_name}`,
            backgroundColor: `${color}`,
            borderColor: `${color}`,
            data: all[j].id,
          });
          color = "#";
        }
        // console.log('dataset = ',dataset);

        this.barData = {
          labels: this.label,
          datasets: dataset,
        };

      //datasets of pieData
      var labelPie = [];
      var colorPie = [];
      var dataPie = [];
for (let j = 0; j < val.length; j++) {

        labelPie.push(`${resultPie[j].system_name}`);
          for (let k = 0; k < 6; k++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          colorPie.push(`${color}`);
          dataPie.push(resultPie[j].amount_type);
          color = "#";
        }

        // console.log('datasetPieData = ',datasetPieData);
        // console.log('labelPie = ',labelPie);
        // console.log('colorPie = ',colorPie);
        // console.log('dataPie = ',dataPie);

        this.pieData = {
          
          labels: labelPie,
          datasets: [
                    {
                        data: dataPie,
                        backgroundColor: colorPie,
                        hoverBackgroundColor: colorPie
                    }
                ],
        };
      }
    },
  },
  created() {
    this.chartOptions.push({ id: 1, name: "แบบ Bar", value: "bar" });
    this.chartOptions.push({ id: 2, name: "แบบ Pie", value: "pie" });
    this.chartOptions.push({ id: 3, name: "แบบ Line", value: "line" });
    this.chartOptions.push({ id: 4, name: "แบบ Doughnut", value: "doughnut" });
    this.selectedStartMonth = { id: "01", name: "มกราคม", shrt: "ม.ค." };
    var current_month, found;
    if (`${new Date().getMonth() + 1}`.length == 1) {
      current_month = `0${new Date().getMonth() + 1}`;
      found = this.month.find((x) => x.id === current_month);
    } else {
      current_month = `${new Date().getMonth() + 1}`;
      found = this.month.find((x) => x.id === current_month);
    }
    this.selectedEndMonth = {
      id: current_month,
      name: `${found.name}`,
      shrt: `${found.shrt}`,
    };

    var current_year = new Date().getFullYear();
    this.selectedStartYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    this.selectedEndYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    for (let i = 0; i < 12; i++) {
      this.year.push({ id: `${current_year}`, name: `${current_year + 543}` });
      current_year--;
    }
  },

  methods: {
    search: function () {
      this.table = [];
      this.headerYear = [];
      this.label = [];
      this.barData =  {}
      this.pieData =  {}
      if (this.selectedStartYear.id <= this.selectedEndYear.id) {
        if (this.selectedStartYear.id == this.selectedEndYear.id) {
            if (this.selectedStartMonth.id <= this.selectedEndMonth.id) {
                this.setHeader();
            }
          }else{
                this.setHeader();
          }
      } 
    },

    async setHeader() {
      this.range_arr = [];
      this.table = [];
      this.headerYear = [];
      this.label = [];
      this.labelGraph = `${this.selectedStartMonth.name} ${this.selectedStartYear.name} ถึง ${this.selectedEndMonth.name} ${this.selectedEndYear.name}`;
      if (this.selectedStartYear.id == this.selectedEndYear.id) {
        var start = Number(this.selectedStartMonth.id);
        var end = Number(this.selectedEndMonth.id);
        for (let i = start - 1; i <= end - 1; i++) {
          this.headerYear.push([
            `${this.month[i].shrt}${this.selectedStartYear.name}`,
          ]);
          this.label.push(
            `${this.month[i].shrt}${this.selectedStartYear.name}`
          );
          this.range_arr.push(
            `${this.month[i].id}/${this.selectedStartYear.id}`
          );
        }
      } else {
        var startY = Number(this.selectedStartYear.id);
        var endY = Number(this.selectedEndYear.id);
        var diff_year = endY - startY - 1;
        if (diff_year == 0) {
          var startM = Number(this.selectedStartMonth.id);
          var endM = Number(this.selectedEndMonth.id);
          for (let i = startM; i <= 12; i++) {
            this.headerYear.push([
              `${this.month[i - 1].shrt}${this.selectedStartYear.name}`,
            ]);
            this.label.push(
              `${this.month[i - 1].shrt}${this.selectedStartYear.name}`
            );
            this.range_arr.push(
              `${this.month[i - 1].id}/${this.selectedStartYear.id}`
            );
          }
          for (let i = 0; i < endM; i++) {
            this.headerYear.push([
              `${this.month[i].shrt}${this.selectedEndYear.name}`,
            ]);
            this.label.push(
              `${this.month[i].shrt}${this.selectedEndYear.name}`
            );
            this.range_arr.push(
              `${this.month[i].id}/${this.selectedEndYear.id}`
            );
          }
        } else {
          var year_range = [this.selectedStartYear.id, this.selectedEndYear.id];
          for (let i = 0; i < diff_year; i++) {
            var check = `${Number(year_range[i]) + 1}`;
            year_range.splice(i + 1, 0, check);
          }
          // console.log(year_range);
          var startM_2 = Number(this.selectedStartMonth.id);
          var endM_2 = Number(this.selectedEndMonth.id);
          for (let i = startM_2; i <= 12; i++) {
            this.headerYear.push([
              `${this.month[i - 1].shrt}${this.selectedStartYear.name}`,
            ]);
            this.label.push(
              `${this.month[i - 1].shrt}${this.selectedStartYear.name}`
            );
            this.range_arr.push(
              `${this.month[i - 1].id}/${this.selectedStartYear.id}`
            );
          }
          for (let j = 1; j < year_range.length - 1; j++) {
            for (let i = 0; i < 12; i++) {
              this.headerYear.push([
                `${this.month[i].shrt}${Number(year_range[j]) + 543}`,
              ]);
              this.label.push(
                `${this.month[i].shrt}${Number(year_range[j]) + 543}`
              );
              this.range_arr.push(
                `${this.month[i].id}/${Number(year_range[j])}`
              );
            }
          }
          for (let i = 0; i < endM_2; i++) {
            this.headerYear.push([
              `${this.month[i].shrt}${this.selectedEndYear.name}`,
            ]);
            this.label.push(
              `${this.month[i].shrt}${this.selectedEndYear.name}`
            );
            this.range_arr.push(
              `${this.month[i].id}/${this.selectedEndYear.id}`
            );
          }
        }
      }
      this.loading = true;
      // console.log("this.selectedStartYear.id",this.selectedStartYear.id)
      // console.log("this.selectedEndYear.id",this.selectedEndYear.id)
      // console.log("this.selectedStartMonth.id",this.selectedStartMonth.id)
      // console.log("this.selectedEndMonth.id",this.selectedEndMonth.id)
      await this.axios
        .post(`${this.$url_service}/get/statistic`, {
          body: {
            topic: "get-mainpage",
            start_month: this.selectedStartMonth.id,
            end_month: this.selectedEndMonth.id,
            start_year: this.selectedStartYear.id,
            end_year: this.selectedEndYear.id,
          },
        })
        .then((response) => (this.table = response.data.data));
        this.loading = false;
    },
  },
};
</script>
<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
/* div.ex1 {
  background-color: lightblue;
  overflow: scroll;
} */


/* ! ส่วนกราฟ */
.chartAreaWrapper {
       width: 100%;
       overflow-x: scroll;
  }

.walking-speed-chart{
       /* margin-top: 20px; */
       height: 80%;
       width: 880px;
  }


  @media screen and (max-width: 1540px) {
    .walking-speed-chart{
       height: 80%;
       width: 690px;
  }

}

/* ! จบส่วนกราฟ */

</style>

